import { GetListingsV3PublicEndpoint } from '@kouto/types';
import { ListingsV3QueryProps } from 'types/listingV3';

const buildListingsV3Url = (params?: ListingsV3QueryProps) => {
  return GetListingsV3PublicEndpoint.url({
    query: {
      page: params?.page,
      limit: params?.limit,
      isUnlisted: params?.isUnlisted,
      categoryIds: params?.categoryIds,
      vibeIds: params?.vibeIds,
      productLines: params?.productLines,
      language: params?.language,
      sortBy: params?.sortBy,
      sortDir: params?.sortDir,
    },
  });
};

export default buildListingsV3Url;
